module.exports = __webpack_public_path__ + "static/growth_analytics-5e719a723901e82608829a0210d5079b.svg";